/* eslint-disable */
export default {
  copyToClipboard: 'Copiar en el Portapapeles',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
